const ADMIN_AUTH_KEY = "adminAuth";

export function getAdminAuth() {
  try {
    const raw = localStorage.getItem(ADMIN_AUTH_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setAdminAuth({ accessToken, refreshToken, admin }) {
  localStorage.setItem(
    ADMIN_AUTH_KEY,
    JSON.stringify({ accessToken, refreshToken, admin })
  );
}

export function clearAdminAuth() {
  localStorage.removeItem(ADMIN_AUTH_KEY);
}

export function updateStoredAdmin(admin) {
  const auth = getAdminAuth();
  if (!auth) return;
  setAdminAuth({ ...auth, admin });
}

export function isAdminLoggedIn() {
  return Boolean(getAdminAuth()?.accessToken);
}
